export default "__VITE_ASSET__B8msDXQr__"